import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PROFILE } from "../../constants/RoutesUrl";
import ImageComponent from "../common/ImageComponent";
import SearchResultCard from "./SearchResultCard";
import Avatar from "../../assets/images/icon/placeholder_Awatar.png";
import { resolveAgendaImageUrl } from "../../utils/agendaUtils";
import { _imagesURL } from "../../constants/API";
import { followUserApi } from "../../services/feedApis";
import { toast } from "react-toastify";
import { Language } from "../../App";
import { LuStethoscope, LuUserCheck, LuUserPlus, LuUserX } from "react-icons/lu";
import "../../pages/search/SearchPage.css";

export function DoctorCard({ item, onFollow, fallbackName = "Doctor", subtitle }) {
  const { lang } = useContext(Language);
  const avatarUrl = resolveAgendaImageUrl(item?.image, Avatar);
  const displayName = item?.name || [item?.firstname, item?.lastname].filter(Boolean).join(" ") || item?.user_name || fallbackName;
  const specialty = subtitle || item?.user_title || item?.specialty || item?.subcategory || item?.category || "";
  const isFollowing = Boolean(item?.follow || item?.is_following);

  return (
    <div className="search-doctor-card">
      <Link
        to={`${PROFILE}/${item?.user_name || item?.id}`}
        className="search-doctor-profile-link"
      >
        <div className="search-doctor-avatar-wrap">
          <ImageComponent
            src={avatarUrl}
            img_height="100%"
            img_width="100%"
            loader_height="100%"
            loader_width="100%"
            compClassName="rounded-circle"
            roundShimmerSize={54}
          />
        </div>
        <div className="search-doctor-info">
          <h4 className="search-doctor-name">{displayName}</h4>
          {item?.user_name && (
            <p className="search-doctor-handle">@{item.user_name.replace(/^@/, "")}</p>
          )}
          {specialty && (
            <p className="search-doctor-specialty">{specialty}</p>
          )}
        </div>
      </Link>

      {onFollow && (
        <button
          type="button"
          className={`search-doctor-follow-btn ${isFollowing ? "following" : "follow"}`}
          onClick={(e) => onFollow(item?.id, e)}
        >
          {isFollowing ? (
            <>
              <LuUserCheck size={14} />
              <span>{lang?.following || "Following"}</span>
            </>
          ) : (
            <>
              <LuUserPlus size={14} />
              <span>{lang?.follow || "Follow"}</span>
            </>
          )}
        </button>
      )}
    </div>
  );
}

export default function DoctorsResultsComp({ data, keyword, loading }) {
  const [searchData, setSearchData] = useState(data);
  const { lang } = useContext(Language);

  const handleFollow = async (id, e) => {
    e?.preventDefault();
    e?.stopPropagation();
    const isFollowed = searchData?.find((item) => item?.id === id)?.follow;
    try {
      const response = await followUserApi(id);
      if (response.status) {
        toast.success(response.message);
        const updatedData = searchData?.map((item) => {
          if (item?.id === id) {
            return { ...item, follow: !isFollowed, is_following: !isFollowed };
          }
          return item;
        });
        setSearchData(updatedData);
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    setSearchData(data);
  }, [data]);

  if (!loading && (!searchData || searchData.length === 0)) {
    return null;
  }

  return (
    <SearchResultCard
      id="doctors"
      icon={<LuStethoscope />}
      title={lang?.doctors || "Doctors"}
      count={searchData?.length}
      link={`/search/doctors?keyword=${encodeURIComponent(keyword || "")}`}
      seeAll={!loading && searchData?.length > 3}
    >
      {loading ? (
        <div className="search-doctors-list">
          {[1, 2, 3].map((n) => (
            <div key={n} className="search-doctor-card">
              <div className="search-doctor-profile-link">
                <div
                  className="search-doctor-avatar-wrap search-shimmer-box"
                />
                <div className="search-doctor-info" style={{ width: "60%" }}>
                  <div className="search-shimmer-box mb-2" style={{ height: "15px", width: "70%" }} />
                  <div className="search-shimmer-box" style={{ height: "12px", width: "45%" }} />
                </div>
              </div>
              <div className="search-shimmer-box" style={{ height: "32px", width: "80px", borderRadius: "999px" }} />
            </div>
          ))}
        </div>
      ) : searchData && searchData.length > 0 ? (
        <div className="search-doctors-list">
          {searchData.slice(0, 3).map((item, index) => (
            <DoctorCard
              key={item?.id || index}
              item={item}
              onFollow={handleFollow}
            />
          ))}
        </div>
      ) : (
        <div className="search-empty-state-card">
          <div className="search-empty-icon-wrap">
            <LuUserX />
          </div>
          <h5 className="search-empty-title">{lang?.no_doctors_found || "No doctors found"}</h5>
          <p className="search-empty-desc">
            {lang?.try_different_keyword || "Try a different keyword or check spelling."}
          </p>
        </div>
      )}
    </SearchResultCard>
  );
}
